import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipVertically16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFlipVertically16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m12.989 11.853-1.188-8a1 1 0 0 0-.99-.853H9.504V2h1.309a2 2 0 0 1 1.978 1.706l1.188 8A2 2 0 0 1 12 14H9.503v-1H12a1 1 0 0 0 .989-1.147M6.494 2v1H5.181a1 1 0 0 0-.989.854l-1.18 8A1 1 0 0 0 4 13h2.493v1H4.001a2 2 0 0 1-1.98-2.292l1.182-8A2 2 0 0 1 5.18 2zm2.004-.5a.5.5 0 0 0-1 0v13a.5.5 0 0 0 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlipVertically16);
